/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TooltipEnum} from '../../../../shared/tooltip/tooltip.enum';
import {SpecialOrderPositionValidationResultModel} from '../../../../api/ms-specialorders/contracts/special-order-position-validation-result.model';
import {ExcelUploadService} from '../excel-upload.service';
import {Subscription} from 'rxjs';
import {ApiErrorDetailModel} from '../../../../api/generic/contracts/api-error-detail.model';

@Component({
    selector: 'app-excel-upload-modal',
    templateUrl: './excel-upload-modal.component.html',
    styleUrls: ['./excel-upload-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExcelUploadModalComponent {
    @Output() validMaterialsEmitter = new EventEmitter<SpecialOrderPositionValidationResultModel[]>();
    validMaterials: SpecialOrderPositionValidationResultModel[] = [];
    invalidMaterials: SpecialOrderPositionValidationResultModel[] = [];
    TooltipEnum = TooltipEnum;
    private subscriptions = new Subscription();

    constructor(public activeModal: NgbActiveModal,
                private excelService: ExcelUploadService) {
        this.subscriptions.add(excelService.validMaterialsChange.subscribe(m => {
            this.validMaterials = m;
        }));

        this.subscriptions.add(excelService.invalidMaterialsChange.subscribe(m => {
            this.invalidMaterials = m;
        }));
    }

    mapErrorMessages(errors: ApiErrorDetailModel[]): string {
        if (errors == null || errors.length === 0) {
            return null;
        }

        return errors.map(e => e.description).join('<br>');
    }

    continue(): void {
        this.subscriptions.unsubscribe();
        this.validMaterialsEmitter.emit(this.validMaterials);
        this.activeModal.close();
    }
}
